<template>
    <div name="login-header" class="header">
        <img class="logo" src="../../assets/barocare_logo.png" />
        <span class="title">환자 정보를 입력해 주세요</span>
        <span class="text">간편한 비대면진료를 위한 한 번의 환자 등록!<br/>
            <span class="bold">진료 받으실 분의 정보</span>를 등록해 주세요</span>
    </div>
</template>

<script>


export default {
    name: 'loginHeader',
}
</script>

<style scoped>
    .header {
        width: 100%;
        padding: 30px 16px 40px 16px;
        background: var(--Gray-20, #F3F5F8);
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }
    .logo {
        width: 94px;
        flex-shrink: 0;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
        margin-top: 28px;
    }
    .text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 16px;
    }
    .bold {
        font-weight: 600;
        color: var(--Gray-100, #1E1E1E);
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/LoginHeader.vue